import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import useSeo from '@/hooks/useSeo';
import { faqs } from '@/mocks/faq';

export default function Faq() {
  const base = (window as unknown as { __BASE_PATH__?: string }).__BASE_PATH__ ?? '';
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  useSeo({
    title: '常见问题 - 韩漫榜单解读与选漫答疑',
    description: '关于韩国漫画排行榜、人气榜评分榜必看榜区别、榜单更新频率与选漫建议的常见问题解答，帮你快速上手不再书荒。',
    keywords: '韩国漫画排行榜,韩漫常见问题,韩漫选漫建议,韩漫人气榜,韩漫评分榜',
    canonicalPath: '/faq',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((f) => ({
          '@type': 'Question',
          name: f.question,
          acceptedAnswer: { '@type': 'Answer', text: f.answer },
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: `${origin}${base}/` },
          { '@type': 'ListItem', position: 2, name: '常见问题', item: `${origin}${base}/faq` },
        ],
      },
    ],
  });

  return (
    <Layout>
      <div className="border-b border-background-200 bg-background-100/60">
        <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
          <nav className="flex items-center gap-2 text-sm text-foreground-500" aria-label="面包屑">
            <Link to="/" className="transition-colors hover:text-primary-700">首页</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-800">常见问题</span>
          </nav>
          <h1 className="mt-4 font-heading text-3xl font-black text-foreground-950 md:text-4xl">韩漫选漫常见问题</h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            关于榜单解读、更新频率与选漫建议的答疑汇总。如果还有疑问，欢迎通过邮箱联系我们。
          </p>
        </div>
      </div>

      <div className="mx-auto w-full max-w-4xl px-4 py-10 md:px-6 md:py-14">
        <div className="space-y-4">
          {faqs.map((f) => (
            <details key={f.question} className="group rounded-lg border border-background-200 bg-background-50 p-6 open:border-primary-200">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-3">
                <h2 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{f.question}</h2>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-transform group-open:rotate-45">
                  <i className="ri-add-line" />
                </span>
              </summary>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">{f.answer}</p>
            </details>
          ))}
        </div>

        <div className="mt-10 rounded-lg border border-accent-200 bg-accent-100/70 p-8 text-center">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
            <i className="ri-mail-send-line text-xl" />
          </span>
          <h2 className="mt-4 font-heading text-xl font-bold text-foreground-950">还有疑问？欢迎留言</h2>
          <p className="mt-2 text-sm text-foreground-700">把你想了解的韩漫问题或宝藏作品推荐发给我们，我们会及时回复。</p>
          <a
            href="mailto:hello@hanmanjingxuan.cn"
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-mail-line text-sm" />
            联系我们
          </a>
        </div>
      </div>
    </Layout>
  );
}